import { render, staticRenderFns } from "./TransferAccount.vue?vue&type=template&id=286dd80a&scoped=true&"
import script from "./TransferAccount.vue?vue&type=script&lang=js&"
export * from "./TransferAccount.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccount.vue?vue&type=style&index=0&id=286dd80a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286dd80a",
  null
  
)

export default component.exports